import React, { useContext, useEffect, useState } from "react";
import { UserContext, backendUrl } from "../App";
import axios from "axios";

const Health = () => {
  const { user, setUser } = useContext(UserContext);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    setUserData(user);
    console.log("user", user);
  }, [user]);

  return (
    <section className="relative">
      <div className="max-w-6xl px-4 mx-auto sm:px-6">
        <div className="pt-10 pb-5 md:pt-10 md:pb-5">
          <div className="pb-2 text-center md:pb-2">
            <h1 className="mb-2 text-5xl font-extrabold tracking-tighter md:text-6xl leading-tighter">
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-green-400">
                Health
              </span>
            </h1>
          </div>
          <section className="text-gray-800 rounded-md body-font bg-slate-100">
            <div className="container px-5 py-10 mx-auto">
              <div className="mb-10 text-center">
                <h1 className="mb-4 text-2xl font-bold text-center text-gray-900 sm:text-3xl title-font">
                  {user.userName && <>Your Stats </>}
                </h1>
              </div>
              <div className="flex flex-wrap -mx-2 lg:w-4/5 sm:mx-auto sm:mb-2">
                <div className="w-full p-2 sm:w-1/2">
                  <div className="flex items-center h-full p-4 bg-gray-100 rounded">
                    <span className="font-medium title-font">
                      <b>Age</b> : {userData.age}
                    </span>
                  </div>
                </div>
                <div className="w-full p-2 sm:w-1/2">
                  <div className="flex items-center h-full p-4 bg-gray-100 rounded">
                    <span className="font-medium title-font">
                      <b>Gender</b> : {userData.gender}
                    </span>
                  </div>
                </div>
                <div className="w-full p-2 sm:w-1/2">
                  <div className="flex items-center h-full p-4 bg-gray-100 rounded">
                    <span className="font-medium title-font">
                      <b>Weight</b> : {userData.weight}
                    </span>
                  </div>
                </div>
                <div className="w-full p-2 sm:w-1/2">
                  <div className="flex items-center h-full p-4 bg-gray-100 rounded">
                    <span className="font-medium title-font">
                      <b>Height</b> : {userData.height}
                    </span>
                  </div>
                </div>
                <div className="w-full p-2 sm:w-1/2">
                  <div className="flex items-center h-full p-4 bg-gray-100 rounded">
                    <span className="font-medium title-font">
                      <b>Goal</b> : {userData.goal}
                    </span>
                  </div>
                </div>
              </div>
              <Modal realUserData={userData} setRealUserData={setUserData} />
            </div>
          </section>
        </div>
      </div>
    </section>
  );
};

export default Health;

export const Modal = ({
  realUserData,
  setRealUserData,
  userDoesNotExist,
  setUserDoesNotExist,
}) => {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    if (userDoesNotExist) {
      setShowModal(true);
    }
  }, [userDoesNotExist]);

  const {
    age,
    setAge,
    weight,
    setWeight,
    height,
    setHeight,
    gender,
    setGender,
    user,
    setUser,
    goal, setGoal
  } = useContext(UserContext);

  const [userData, setUserData] = useState(realUserData);
  useEffect(() => {
    setUserData(realUserData);
  }, [realUserData]);


  const saveChanges = async () => {
    const token = localStorage.getItem("self_care_token");
    await axios
      .post(
        `${backendUrl}/api/user/createuser`,
        {
          email: user.email,
          name: user.userName,
          age,
          height,
          weight,
          gender,
          photoURL: user.photoURL,
          goal: goal
        },
        {
          headers: {
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        setShowModal(false);
        setUserDoesNotExist(false);
        setUser(res.data)
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      <button
        className="flex px-8 py-2 mx-auto mt-16 text-lg text-white bg-indigo-500 border-0 rounded focus:outline-none hover:bg-indigo-600"
        type="button"
        onClick={() => setShowModal(true)}
      >
        Edit
      </button>
      {showModal ? (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div className="relative w-auto max-w-3xl mx-auto my-6">
              {/*content*/}
              <div className="relative flex flex-col w-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-blueGray-200">
                  <h3 className="text-3xl font-semibold">Edit your details</h3>
                  <button
                    className="float-right p-1 ml-auto text-3xl font-semibold leading-none text-black bg-transparent border-0 outline-none opacity-5 focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="block w-6 h-6 text-2xl text-black bg-transparent outline-none opacity-5 focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative flex-auto p-6">
                  <form>
                    <div className="mb-4">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="gender"
                      >
                        Gender
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="gender"
                        type="text"
                        placeholder="Gender"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      />

                      {/* <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="name"
                        type="text"
                        placeholder="Name"
                        value={userData.name}
                        onChange={(e) =>
                          setUserData({ ...userData, name: e.target.value })
                        }
                      /> */}
                    </div>
                    <div className="mb-4">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="age"
                      >
                        Age
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="age"
                        type="number"
                        placeholder="Age"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="weight"
                      >
                        Weight
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="weight"
                        type="number"
                        placeholder="Weight"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="height"
                      >
                        Height
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="height"
                        type="number"
                        placeholder="Height"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                      />
                    </div>
                    <div className="mb-4">
                      <label
                        className="block mb-2 text-sm font-bold text-gray-700"
                        htmlFor="goal"
                      >
                        Goal
                      </label>
                      <input
                        className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
                        id="goal"
                        type="number"
                        placeholder="Goal"
                        value={goal}
                        onChange={(e) => setGoal(e.target.value)}
                      />
                    </div>
                  </form>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid rounded-b border-blueGray-200">
                  <button
                    className="px-6 py-2 mb-1 mr-1 text-sm font-bold text-red-500 uppercase transition-all duration-150 ease-linear outline-none background-transparent focus:outline-none"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  <button
                    className="px-6 py-3 mb-1 mr-1 text-sm font-bold text-white uppercase transition-all duration-150 ease-linear rounded shadow outline-none bg-emerald-500 active:bg-emerald-600 hover:shadow-lg focus:outline-none"
                    type="button"
                    onClick={saveChanges}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </>
      ) : null}
    </>
  );
};
